<template>
    <div style="max-width: 600px; margin: auto; text-align: left;">
        <FieldHeader :field="field" />
        <div class="row q-col-gutter-sm">
            <q-input class="col" filled dense type="number" min="0.01" step="any" label="Amount"
                :model-value="modelValue?.amount" :readonly="readOnly"
                @update:model-value="setPart('amount', $event)" @blur="$emit('blur')" />
            <q-select class="col" filled dense label="Unit" emit-value map-options
                :options="units" :model-value="modelValue?.unit" :readonly="readOnly"
                @update:model-value="setPart('unit', $event)" />
        </div>
    </div>
</template>
<script>
import FieldHeader from './FieldHeader.vue';
export default {
    name: 'DurationField', components: { FieldHeader },
    props: { field: Object, modelValue: { type: [Object, String], default: '' }, readOnly: Boolean },
    emits: ['update:modelValue', 'blur'],
    computed: {
        units() {
            return (this.field.options?.units || ['minute', 'hour', 'day', 'week', 'month', 'year'])
                .map(value => ({ value, label: `${value}(s)` }));
        },
    },
    methods: {
        setPart(key, value) {
            this.$emit('update:modelValue', { amount: this.modelValue?.amount ?? '', unit: this.modelValue?.unit || this.units[0]?.value, [key]: value });
        },
    },
};
</script>
